import { isAuthFailureResponse, withTokenRetry } from "./with-token-retry"

interface AuthedRequest {
  account: string
  userId: string
  getNeedSignTerms?: () => boolean
}

export type RenderUrlResult =
  | { kind: "url", url: string }
  | { kind: "error", status: number }

/** Asks pi-server for the URL an HTML artifact renders from. That URL carries a short-lived ticket:
 *  this call is where the render is authorized, and the render routes only verify what it hands
 *  back. Mint a fresh URL per mount and never store one — past the ticket's TTL the render route
 *  serves an error page instead of the artifact. */
export async function getArtifactRenderUrl(url: string, { account, userId, getNeedSignTerms }: AuthedRequest): Promise<RenderUrlResult> {
  try {
    const response = await withTokenRetry({
      account,
      userId,
      getNeedSignTerms,
      attempt: (token) => fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "application/json", "X-OmegaPoint-Code": token },
      }),
      isAuthFailure: isAuthFailureResponse,
    })

    if (!response.ok) return { kind: "error", status: response.status }

    const body = await response.json()
    if (typeof body?.url !== "string") return { kind: "error", status: 0 }
    return { kind: "url", url: body.url }
  } catch {
    return { kind: "error", status: 0 }
  }
}
